import { Checkbox, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { DatePicker } from '@mui/x-date-pickers'
import { useTranslation } from 'react-i18next'
import dayjs from "dayjs"

const SystemAnnouncementModal = ({ values, handleChange, errors, }) => {
    const { t } = useTranslation()

    return (
        <>
            <Typography
                variant="h6"
                sx={{
                    px: 2,
                    py: 1.5
                }}>
                {t('systemAnnouncement.title')}
            </Typography>
            <Divider sx={{
                my: 0
            }} />
            <Grid container sx={{
                py: 1
            }} spacing={{ xs: 2, md: 0 }}>
                <Grid size={{ xs: 12, md: 4 }} sx={{ borderRight: { xs: "none", sm: `1px dashed ${grey[200]}` } }}>
                    <Grid container spacing={1} sx={{ px: 2 }}>
                        <Grid size={{ xs: 12 }}>
                            <Typography variant='body1'>{t('general.general')}</Typography>
                        </Grid>
                        <Grid size={{ xs: 12 }} pb={1}>
                            <Divider />
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Grid container spacing={2}>
                                <Grid size={{ xs: 12 }}>
                                    <DatePicker
                                        minDate={dayjs().toDate()}
                                        variant="standard"
                                        format="dd-MM-yyyy"
                                        id="start-date"
                                        label={t('general.startDate')}
                                        value={values?.startDate ? new Date(values.startDate) : null}
                                        slotProps={{
                                            openPickerButton: { edge: "end", size: "small" },
                                            textField: {
                                                variant: "outlined",
                                                error: !!errors?.startDate,
                                                helperText: errors?.startDate,
                                                size: "small",
                                                fullWidth: true,
                                                InputLabelProps: {
                                                    shrink: true,
                                                }
                                            },
                                        }}
                                        enableAccessibleFieldDOMStructure={false}
                                        onChange={(date) => handleChange({ keyName: "startDate", value: dayjs(new Date(date).toJSON()).format("YYYY-MM-DD") })}
                                        onError={errors?.startDate}

                                    />

                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <DatePicker
                                        minDate={
                                            values?.startDate
                                                ? dayjs(values?.startDate).toDate()
                                                : dayjs().toDate()
                                          }
                                        variant="standard"
                                        format="dd-MM-yyyy"
                                        value={values?.endDate ? new Date(values.endDate) : null}
                                        id="start-date"
                                        label={t('general.endDate')}
                                        slotProps={{
                                            openPickerButton: { edge: "end", size: "small" },
                                            textField: {
                                                variant: "outlined",
                                                error: !!errors?.endDate,
                                                helperText: errors?.endDate,
                                                size: "small",
                                                fullWidth: true,
                                                InputLabelProps: {
                                                    shrink: true,
                                                }
                                            },
                                        }}
                                        enableAccessibleFieldDOMStructure={false}
                                        onChange={(date) => handleChange({ keyName: "endDate", value: dayjs(new Date(date).toJSON()).format("YYYY-MM-DD") })}
                                        onError={errors?.endDate}

                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label={t('general.description')}
                                        value={values?.desc}
                                        autoComplete='off'
                                        size='small'
                                        fullWidth
                                        error={errors?.desc}
                                        helperText={errors?.desc}
                                        onChange={(e) =>
                                            handleChange({ keyName: "desc", value: e.target.value })
                                        } />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values?.isBuyerGuidance}
                                                    onChange={(e) =>
                                                        handleChange({
                                                            keyName: "isBuyerGuidance",
                                                            value: e.target.checked
                                                        })
                                                    }
                                                />
                                            }
                                            label={t("app.name.huisinfo")}
                                        />
                                        {errors?.isBuyerGuidance && (
                                            <Typography color="error" variant="caption">
                                                {errors.isBuyerGuidance}
                                            </Typography>
                                        )}
                                    </Grid>

                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values?.isAftercare}
                                                    onChange={(e) =>
                                                        handleChange({
                                                            keyName: "isAftercare",
                                                            value: e.target.checked
                                                        })
                                                    }
                                                />
                                            }
                                            label={t('app.name.aftercare')}
                                        />
                                        {errors?.isAftercare && (
                                            <Typography color="error" variant="caption">
                                                {errors.isAftercare}
                                            </Typography>
                                        )}
                                    </Grid>

                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <Grid size={{ xs: 12 }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values?.active}
                                                    onChange={(e) =>
                                                        handleChange({
                                                            keyName: "active",
                                                            value: e.target.checked
                                                        })
                                                    }
                                                />
                                            }
                                            label={t("general.active")}
                                        />
                                        {errors?.active && (
                                            <Typography color="error" variant="caption">
                                                {errors.active}
                                            </Typography>
                                        )}
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SystemAnnouncementModal
